import React from "react";
import Typography from "@material-ui/core/Typography";
import { EmbeddedDoc, EmbeddedDocMobile } from "./FaqPage";

export const Constitution = ({ refProp, isMobile }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Constitution & Appendices</u>
      </Typography>
      {isMobile ? (
        <EmbeddedDocMobile
          text={"Community Constitution: "}
          href={
            "https://docs.google.com/document/d/1EeVTzyInCELyf1cwCevMQX6uLuqmVz9Awq7iv108F64/edit?rm=minimal"
          }
        />
      ) : (
        <EmbeddedDoc>
          <iframe
            title={"mobileConstitution"}
            src={
              "https://docs.google.com/document/d/1EeVTzyInCELyf1cwCevMQX6uLuqmVz9Awq7iv108F64/edit?rm=minimal"
            }
          />
        </EmbeddedDoc>
      )}
      {isMobile ? (
        <EmbeddedDocMobile
          text={"Appendicies:"}
          href={
            "https://docs.google.com/document/d/1YjYzajUq0HrwHx6XGKKEJM6dFQ4ZI687VErDVyoZBUs/edit?rm=minimal"
          }
        />
      ) : (
        <EmbeddedDoc>
          <iframe
            title={"mobileConstitutionAppendicies"}
            src={
              "https://docs.google.com/document/d/1YjYzajUq0HrwHx6XGKKEJM6dFQ4ZI687VErDVyoZBUs/edit?rm=minimal"
            }
          />
        </EmbeddedDoc>
      )}
    </div>
  );
};

export default Constitution;
